import { Typography, type TypographyProps } from '@mui/material'

export type SectionSubtitleProps = TypographyProps

const DEFAULT_VARIANT = 'caption'
const DEFAULT_COLOR = 'text.secondary'

export function SectionSubtitle(props: SectionSubtitleProps) {
  return <Typography variant={DEFAULT_VARIANT} color={DEFAULT_COLOR} {...props} />
}
